export const StatusBarEvent = {
  ERROR: 'StatusBarError',
  WARNING: 'StatusBarWarning',
  SUCCESS: 'StatusBarSuccess'
}
